import React, { useState } from "react";
import { IBlogPostLayoutProps } from "./utils";
import { FaFacebookF, FaInstagram, FaLinkedin, FaLinkedinIn, FaPinterest, FaRegEnvelope, FaTiktok, FaTwitter, FaVimeo, FaYoutube, FaSearch } from "react-icons/fa";
import { Button } from "../Button";
import { ESocialChannel } from "../../lib/Contact/types";
import { EntrySearch } from "../Search/EntrySearch";
import { ISearchContext, Text } from "../Search";

export const PostLayoutSearchColumn: React.FC<IBlogPostLayoutProps> = ({
    title,
    post,
    className = "",
    colsWrapperClassName = "",
    titleWrapperClassName = "",
    tileClassName = "",
    postSearchBasePath,
    categoryParamName = "category",
    tagParamName = "tag",
    textParamName = "text",
    shareOnTwitter = true,
    shareOnFacebook = true,
    shareOnLinkedIn = true,
    shareOnEmail = true,
    recentPosts,
    allCategories,
    allTags,
    socialMediaLinks,
    linkFunc,
}) => {
    const linkf = linkFunc || ((props) => <a {...props} />);

    let author_date: string | undefined = undefined
    if (post.author || post.date) {
        author_date = "Posted"
        if (post.date) {
            const formatedDate = new Intl.DateTimeFormat("en-us", {
                dateStyle: "long"
            }).format(post.date)
            author_date = `${author_date} on ${formatedDate}`
        }
        if (post.author) {
            author_date = `${author_date} by ${post.author}`
        }
    }

    const [isCategoriesCollpsed, setCategoriesCollapsed] = useState(true)
    const [isTagsCollpsed, setTagsCollapsed] = useState(true)

    const entrySearch = (
        <EntrySearch
            className="!p-0"
            buttonClassName="-mx-3 !min-w-0"
            buttonText={<FaSearch />}
            onSubmit={async filters => {
                const params = new URLSearchParams({
                    filters: JSON.stringify(filters),
                })
                if (typeof window != "undefined") {
                    window.location.href = `${postSearchBasePath}#${params.toString()}`
                }
            }}
            standardFilters={(context: ISearchContext) => (
                <Text
                    className="col-span-2 md:col-span-4"
                    inputClassName="w-full border"
                    label="Search"
                    placeholder="Search..."
                    param={textParamName}
                    context={context}
                    resolver={(arg: any, text) => { return true }}
                />
            )}
        />
    )

    const locationOrigin = typeof window != "undefined" ? window.location.origin : "";

    return (
        <div className={`blog-post-layout mx-auto ${className}`}>
            {title && (
                <div className={`w-full ${titleWrapperClassName}`}>
                    <h1 className={`${tileClassName}`}>{title}</h1>
                </div>
            )}
            <div className={`w-full mx-auto flex flex-wrap md:flex-nowrap items-start gap-x-2.5 lg:gap-x-10 ${colsWrapperClassName}`}>
                <div className="main-col w-full md:w-8/12">
                    {post.image?.url && (
                        <img src={post.image.url} className="w-full h-auto mb-6" />
                    )}
                    {post.tags?.[0] && postSearchBasePath && (
                        <div className="tags-box flex flex-wrap gap-y-1 pt-4 text-sm">
                            {post.tags.map((tag, index, tags) => (
                                <>
                                    {
                                        linkf({
                                            key: index,
                                            href: encodeURI(`${postSearchBasePath}#filters={"${tagParamName}":"${tag}"}`),
                                            children: tag,
                                            className: "uppercase"
                                        })
                                    }
                                    {index < (tags.length - 1) && (
                                        <>{","}&nbsp;</>
                                    )}
                                </>
                            ))}
                        </div>
                    )}
                    {post.title && (
                        <h1 className="text-left pt-2 pb-1">{post.title}</h1>
                    )}
                    {author_date && (
                        <span>{author_date}</span>
                    )}
                    {post.content && (
                        <div className="content-box pt-5" dangerouslySetInnerHTML={{ __html: post.content }}></div>
                    )}
                    {post.buttons?.[0] && (
                        <div className="pt-4 flex flex-wrap justify-center gap-2 buttons-box">
                            {post.buttons.map((btn, index) => (
                                <Button
                                    key={index}
                                    linkProps={{
                                        href: btn.href,
                                        target: btn.target
                                    }}
                                    linkFunc={linkf}>
                                    {btn.text}
                                </Button>
                            ))}
                        </div>
                    )}
                    {post.path && (
                        <div className="social-box flex gap-x-2 pt-4 text-sm">
                            <span className="uppercase">Share:</span>
                            <div className="flex items-center gap-x-2 text-base">
                                {shareOnTwitter && (
                                    <a href={`http://www.twitter.com/share?url=${locationOrigin}${post.path}`} target="_blank">
                                        <FaTwitter />
                                    </a>
                                )}
                                {shareOnFacebook && (
                                    <a href={`https://www.facebook.com/sharer/sharer.php?u=${locationOrigin}${post.path}`} target="_blank">
                                        <FaFacebookF />
                                    </a>
                                )}
                                {shareOnLinkedIn && (
                                    <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${locationOrigin}${post.path}`} target="_blank">
                                        <FaLinkedin />
                                    </a>
                                )}
                                {shareOnEmail && (
                                    <a href={`mailto:?body=${locationOrigin}${post.path}`}>
                                        <FaRegEnvelope />
                                    </a>
                                )}
                            </div>
                        </div>
                    )}
                    {post.categories?.[0] && postSearchBasePath && (
                        <div className="categories-box pt-4 flex gap-x-2 items-start text-sm">
                            <span className="uppercase">Categories:</span>
                            <div className="flex flex-wrap gap-x-2 gap-y-1">
                                {post.categories.map((cat, index, categories) => (
                                    <>
                                        {
                                            linkf({
                                                key: index,
                                                href: encodeURI(`${postSearchBasePath}#filters={"${categoryParamName}":"${cat}"}`),
                                                children: cat,
                                                className: "uppercase"
                                            })
                                        }
                                        {index < (categories.length - 1) && (
                                            <div className="self-stretch w-px border-l"></div>
                                        )}
                                    </>
                                ))}
                            </div>
                        </div>
                    )}
                    {post.agents?.[0] && (
                        <div className="agents-box pt-4 flex gap-x-2 items-start text-sm">
                            <span className="uppercase">Agents:</span>
                            <div className="flex flex-wrap gap-x-2 gap-y-1">
                                {post.agents.map((agent, index, agents) => (
                                    <>
                                        {
                                            linkf({
                                                key: index,
                                                href: agent.path,
                                                children: agent.fullName ?? `${agent.first} ${agent.last}`,
                                                className: "uppercase"
                                            })
                                        }
                                        {index < (agents.length - 1) && (
                                            <div className="self-stretch w-px border-l"></div>
                                        )}
                                    </>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                <div className="w-full md:w-4/12 p-2.5 shadow-xl">
                    <div className="border px-5 divide-y">
                        <div className="py-4 flex flex-col gap-y-2.5">
                            {entrySearch}
                            {socialMediaLinks?.[0] && (
                                <div className="pt-4 flex flex-col gap-y-2.5">
                                    <span className="text-xs uppercase">Follow us on...</span>
                                    <div className="flex flex-row flex-wrap gap-2 w-full text-4xl leading-none">
                                        {socialMediaLinks.map((item, i) => (
                                            <a
                                                key={i}
                                                href={`${item.url}`}
                                                title={item.text}
                                            >
                                                {(() => {
                                                    switch (item.channel) {
                                                        case ESocialChannel.Facebook:
                                                            return <FaFacebookF />;
                                                        case ESocialChannel.Twitter:
                                                            return <FaTwitter />;
                                                        case ESocialChannel.Instagram:
                                                            return <FaInstagram />;
                                                        case ESocialChannel.YouTube:
                                                            return <FaYoutube />;
                                                        case ESocialChannel.LinkedIn:
                                                            return <FaLinkedinIn />;
                                                        case ESocialChannel.Vimeo:
                                                            return <FaVimeo />;
                                                        case ESocialChannel.Pinterest:
                                                            return <FaPinterest />;
                                                        case ESocialChannel.TikTok:
                                                            return <FaTiktok />;
                                                        default:
                                                            return null;
                                                    }
                                                })()}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        {recentPosts?.[0] && (
                            <div className="py-4 flex flex-col gap-y-2.5">
                                <span className="text-xl">Recent Posts</span>
                                <div className="flex flex-col gap-y-1 text-sm">
                                    {recentPosts.map((recent, index) => (
                                        <>
                                            {
                                                linkf({
                                                    key: index,
                                                    href: recent.href,
                                                    children: recent.text,
                                                })
                                            }
                                        </>
                                    ))}
                                </div>
                            </div>
                        )}
                        {allCategories?.[0] && (
                            <div className="py-4 flex flex-col gap-y-2.5">
                                <span className="text-xl">Categories</span>
                                <div className="flex flex-col gap-y-1 text-sm">
                                    {isCategoriesCollpsed && allCategories.slice(0, 4).map((cat, index) => (
                                        <>
                                            {
                                                linkf({
                                                    key: index,
                                                    href: encodeURI(`${postSearchBasePath}#filters={"${categoryParamName}":"${cat}"}`),
                                                    children: cat,
                                                })
                                            }
                                        </>
                                    ))}
                                    {!isCategoriesCollpsed && allCategories.map((cat, index) => (
                                        <>
                                            {
                                                linkf({
                                                    key: index,
                                                    href: encodeURI(`${postSearchBasePath}#filters={"${categoryParamName}":"${cat}"}`),
                                                    children: cat,
                                                })
                                            }
                                        </>
                                    ))}
                                    {allCategories.length > 4 && (
                                        <a className="cursor-pointer uppercase mt-2"
                                            onClick={() => { setCategoriesCollapsed(!isCategoriesCollpsed) }}>
                                            {isCategoriesCollpsed ? "...View More Categories" : "...View Less Categories"}
                                        </a>
                                    )}
                                </div>
                            </div>
                        )}
                        {postSearchBasePath && (
                            <div className="py-4 flex flex-col gap-y-2.5">
                                {linkf({
                                    href: postSearchBasePath,
                                    children: "Archives",
                                    className: "text-xl"
                                })}
                            </div>
                        )}
                        {allTags?.[0] && (
                            <div className="py-4 flex flex-col gap-y-2.5">
                                <span className="text-xl">Topics</span>
                                <div className="flex flex-row flex-wrap gap-1 text-2xl">
                                    {isTagsCollpsed && allTags.slice(0, 4).map((tag, index) => (
                                        <>
                                            {
                                                linkf({
                                                    key: index,
                                                    href: encodeURI(`${postSearchBasePath}#filters={"${tagParamName}":"${tag}"}`),
                                                    children: tag,
                                                })
                                            }
                                        </>
                                    ))}
                                    {!isTagsCollpsed && allTags.map((tag, index) => (
                                        <>
                                            {
                                                linkf({
                                                    key: index,
                                                    href: encodeURI(`${postSearchBasePath}#filters={"${tagParamName}":"${tag}"}`),
                                                    children: tag,
                                                })
                                            }
                                        </>
                                    ))}
                                    {allTags.length > 4 && (
                                        <a className="cursor-pointer uppercase mt-2 text-sm w-full"
                                            onClick={() => { setTagsCollapsed(!isTagsCollpsed) }}>
                                            {isTagsCollpsed ? "...View More Topics" : "...View Less Topics"}
                                        </a>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}


export default PostLayoutSearchColumn
